import * as React from 'react';

const SvgPersonGroup = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", d: "m10.23 15 .73-2H3.3L.75 20h7.66l.73-2H3.61l1.09-3h5.53ZM7.5 11.5c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2ZM17 11.5c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2ZM20.7 13h-7.58l-2.55 7h8.42l-.72-2h-4.84l1.09-3h4.78l1.82 5h2.13l-2.55-7Z" })
);

export { SvgPersonGroup as default };
//# sourceMappingURL=PersonGroup.es.js.map
